import { ApiError, Unauthenticated } from '../../api.js';
import { viewFetch } from '../../view-as.js';
import type { AccessPageData, Applied, Change, ChangeRequest, Changes } from './types.js';
import { wholePreview, type PreviewAnswer } from '../whole-preview.js';

async function request<T>(store: string, path = '', body?: ChangeRequest, signal?: AbortSignal): Promise<T> {
  const res = await viewFetch(`/api/admin/access${path}${path.includes('?') ? '&' : '?'}store=${encodeURIComponent(store)}`, {
    credentials: 'same-origin', ...(signal ? { signal } : {}),
    ...(body === undefined ? {} : { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) }),
  });
  if (res.status === 401) throw new Unauthenticated();
  if (!res.ok) {
    const data = await res.json().catch(() => ({})) as { error?: unknown };
    throw new ApiError(res.status, typeof data.error === 'string' ? data.error : `${res.status} ${res.statusText}`);
  }
  return await res.json() as T;
}
export const accessApi = {
  read: (store: string, signal?: AbortSignal) => request<AccessPageData>(store, '', undefined, signal),
  changes: (store: string, limit: number, signal?: AbortSignal) => request<Changes>(store, `/changes?limit=${limit}`, undefined, signal),
  preview: (store: string, change: Change, signal?: AbortSignal) => request<PreviewAnswer>(store, '/preview', { change }, signal).then(wholePreview),
  apply: (store: string, change: Change, reason?: string) => request<Applied>(store, '/apply', { change, ...(reason ? { reason } : {}) }),
};
